import { memo } from "react";
import { useSelector } from "react-redux";

import { notifierSlice } from "../../slice";

import { Notification } from "./components/notification";

import { NotificationsBox, NotificationsItem } from "./notifications.styles";

const classes = {
  root: {
    left: "50%",
    zIndex: 10000,
    position: "fixed",
    transform: "translateX(-50%)",
  } as const,
  notification: {
    marginTop: 2,
  },
};

function Notifications() {
  const notifications = useSelector(notifierSlice.selectors.select);

  return (
    <NotificationsBox>
      {notifications.map((notification) => (
        <NotificationsItem key={notification.uuid}>
          <Notification notification={notification} />
        </NotificationsItem>
      ))}
    </NotificationsBox>
  );
}

const Wrapper = memo(Notifications);

export { Wrapper as Notifications };
